import { useState } from "react";
import { Modal } from "react-bootstrap";
import { downloadTickets } from "../../api/ticket";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import AlertBox from "../AlertBox";

export default function ModalDownloadTickets({ show, onClose, onSuccess }) {
  const [formFilter, setFormFilter] = useState({ date_from: "", date_until: "", project_id: "" });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);
  const { projects } = useGroupListHooks();

  const handleClose = () => {
    resetFilter();
    onClose();
  };

  const resetFilter = () => {
    setFormFilter({ date_from: "", date_until: "", project_id: "" });
  };

  const downloadFile = async () => {
    setLoading(true);
    try {
      let response = await downloadTickets({ ...formFilter });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Data Ticket.xlsx");
      onSuccess("Berhasil mengunduh Data Ticket.xlsx");
      document.body.appendChild(link);
      link.click();
      handleClose();
    } catch (error) {
      let message = "Something wrong ... ";

      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download Data Tiket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <form>
          <div className="form-group">
            <label>Tanggal Dari</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.date_from}
              onChange={(event) => setFormFilter({ ...formFilter, date_from: event.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Tanggal Sampai</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.date_until}
              onChange={(event) => setFormFilter({ ...formFilter, date_until: event.target.value })}
            />
          </div>
          <div className="form-group">
            <label htmlFor="projectFilter">Grup/Project</label>
            <select
              className="form-control"
              id="projectFilter"
              value={formFilter.project_id}
              onChange={(event) => setFormFilter({ ...formFilter, project_id: event.target.value })}
            >
              <option value="">SEMUA</option>
              {projects.map((project, index) => (
                <option value={project.id} key={index}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => handleClose()}>
          Close
        </button>
        <button className="btn btn-primary" onClick={() => downloadFile()} disabled={loading}>
          <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
